module.exports = __webpack_public_path__ + "static/media/simeon.eff4d024.png";